<div class="modal-body leave-session">
  <div class="text-center leave-class-box">
    <ng-container *ngIf="userTypeId == 1">
      <h4 class="mb-2"><span>Do you want to leave the class?</span></h4>
      <button class="btn btn-primary" type="button" (click)="dismissLeaveSession()">CONTINUE LEARNING</button>
      <button type="button" class="btn-link btn-block skip-btn" (click)="continueLeaveSession()">STOP LEARNING</button>
      <p>You will be able to access class recording in your past classes</p>
    </ng-container>
    <ng-container *ngIf="userTypeId == 2">
      <h4 class="mb-2"><span>Are you sure you want to end the class?</span></h4>
      <button class="btn btn-primary" type="button" (click)="dismissLeaveSession()">CONTINUE WITH CLASS</button>
      <button type="button" class="btn-link btn-block skip-btn" (click)="continueLeaveSession()">YES, END CLASS</button>
    </ng-container>
  </div>
</div>
